import React from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '@pearsontechnology/aero-components';
import { Wrap, Toast, Text, ToastWrap } from './styles';

const Overlay = ({ show }) => (
  <>
    <Wrap data-testid="overlay" show={show}></Wrap >
    <ToastWrap show={show}>
      <Toast>
        <SVGIcon
          icon="offline"
          viewBox="0 0 24 18"
          size={{ width: '24px', height: '18px' }}
        />
        <Text>Please hold on while we try to reconnect.</Text>
      </Toast>
    </ToastWrap>
  </>
);

Overlay.propTypes = {
  show: PropTypes.bool,
};

export default Overlay;
